<template>
    <div class="scrollbar-hidden flex flex-1 flex-col mt-14 min-w-0 bg-white border-r border-gray-200 overflow-x-hidden overflow-y-scroll lg:mt-0">
        <div class="flex">
            <div class="flex flex-col pb-3 pt-16 px-4 w-full space-y-3 sm:space-y-4 md:pb-6 md:pt-6">
                <div v-for="message in messages" role="list">
                    <message :message="message" />
                </div>

                <div class="h-8">
                    <transition name="fade">
                        <div v-show="typing && userTyping" class="flex flex-row space-x-4">
                            <avatar :user="userTyping" class="w-9 h-9"></avatar>
                            <div class="flex items-end pl-4">
                                <div class="dot-falling shadow-dots"></div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Message from "@/Pages/Messenger/Message"

export default {
    components: { Message },

    created() {
        this.$root.$on("scrollToBottom", () => this.scrollToBottom())

        let _this = this
        Echo.private(`conversation.${this.$page.props.conversation.id}`)
            .listenForWhisper("typing", (e) => {
                this.userTyping = e.userTyping
                this.typing = e.typing
                this.$nextTick(() => {
                    this.scrollToBottom()
                })

                // remove is typing indicator after 1.2s
                setTimeout(() => {
                    _this.typing = false
                }, 2000)
            })
            .listen(".incoming.message", (message) => {
                this.typing = false

                // Add incoming message to message list
                this.messages.push(message)
                setTimeout(() => {
                    this.$emit("update:messages", this.messages)
                    this.scrollToBottom()
                }, 2000)
            })
    },

    mounted() {
        this.scrollToBottom()
    },

    // watch: {
    //     messages() {
    // this.scrollToBottom()
    // },
    // },

    props: {
        messages: {
            required: true,
            type: Array | null,
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                _method: "POST",
            }),
            userTyping: null,
            typing: false,
        }
    },

    methods: {
        scrollToBottom() {
            this.$nextTick(() => {
                window.scrollTo(0, document.body.scrollHeight)
            })
        },
    },
}
</script>
